import React from 'react';
import { Badge } from '@mantine/core';
import PropTypes from 'prop-types';

/**
 * IconBadge component that displays a badge with an icon and text
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.icon - Icon element to display
 * @param {string} props.children - Text content to display
 * @param {string} props.color - Badge color (default: 'indigo')
 * @param {string} props.variant - Badge variant (default: 'filled')
 * @param {number} props.size - Badge size (default: 'md')
 * @param {Object} props.sx - Custom styles
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.clickable - Whether the badge is clickable
 */
const IconBadge = ({
    icon,
    children,
    color = 'indigo',
    variant = 'light',
    size = 'md',
    sx = {},
    className = '',
    style = {},
    onClick,
    clickable = false,
    ...otherProps
}) => {
    const defaultSx = {
        maxWidth: 150,
        cursor: clickable ? 'pointer' : 'default',
        transition: clickable ? 'all 0.2s ease' : 'none',
        ...sx
    };

    const handleClick = (event) => {
        if (clickable && onClick) {
            onClick(event);
        }
    };

    return (
        <Badge
            color={color}
            variant={variant}
            size={size}
            style={defaultSx}
            className={className}
            // style={style}
            onClick={handleClick}
            {...otherProps}
            sx={{
                ...style,
                '.mantine-Badge-inner':{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,    
                }
                
            }}
        >
            {icon}
            {children}
        </Badge>
    );
};

IconBadge.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node.isRequired,
    color: PropTypes.string,
    variant: PropTypes.oneOf(['filled', 'outline', 'light', 'white', 'default', 'gradient']),
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    sx: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    clickable: PropTypes.bool
};

export default IconBadge;